// This file is auto-generated by dibs-icons script
import { type FC } from 'react';

type PersonSearch40Props = {
    dataTn?: string;
    role?: 'img';
    ariaLabel?: string;
    ariaLabelledby?: string;
};

const PersonSearch40: FC<PersonSearch40Props> = props => {
    return (
        <svg
            style={{ display: 'block' }}
            data-tn={props.dataTn}
            role={props.role}
            aria-label={props.ariaLabel}
            aria-labelledby={props.ariaLabelledby}
            width="40"
            height="40"
            viewBox="0 0 40 40"
        >
            <path d="M18.347 19.444q-2.652 0-4.527-1.877-1.875-1.876-1.875-4.512 0-2.666 1.876-4.527 1.877-1.862 4.512-1.862 2.667 0 4.528 1.862 1.86 1.86 1.861 4.513 0 2.654-1.86 4.528-1.862 1.875-4.515 1.875m-.014-2.777q1.515 0 2.563-1.061a3.5 3.5 0 0 0 1.049-2.55q0-1.515-1.05-2.563-1.047-1.05-2.548-1.049-1.5 0-2.562 1.049-1.063 1.048-1.063 2.548t1.06 2.563q1.062 1.062 2.551 1.063m18.89 22.5L31.554 33.5a6.7 6.7 0 0 1-1.944.93 7.6 7.6 0 0 1-2.099.292q-3.014 0-5.124-2.108-2.11-2.106-2.11-5.117 0-3.01 2.107-5.115 2.108-2.104 5.118-2.104t5.115 2.11q2.104 2.109 2.104 5.124 0 1.084-.292 2.1a6.7 6.7 0 0 1-.93 1.943l5.667 5.667zm-6.556-8.5q1.278-1.278 1.278-3.167 0-1.89-1.278-3.167-1.278-1.278-3.167-1.278-1.89 0-3.167 1.278-1.278 1.278-1.278 3.167t1.278 3.166 3.167 1.278q1.89 0 3.167-1.277M5 33.332V29.18q0-1.5.722-2.625.723-1.125 2.056-1.805 2.014-1 5-1.82t6.236-.68a9.7 9.7 0 0 0-1.194 2.764q-3 .041-5.265.798-2.263.757-3.597 1.438-.527.29-.854.799a2.05 2.05 0 0 0-.326 1.131v1.375H17.82q.375.778.742 1.459.369.68.84 1.32z" />
        </svg>
    );
};

export default PersonSearch40;
